import { Component, inject } from "@angular/core";
import { UiKitModule } from "@app/ui-kit.module";
import { AlarmDeviceConfiguration } from "@domain/project/configurations/alarm-device-configuration";
import { FgdsProject } from "@domain/project/fgds-project";
import { Floorplan } from "@domain/project/floorplan/floorplan";
import { ConfiguredProductComponent } from "@project/floorplanner/floorplan-menu/fgds/configured-product/configured-product.component";
import { FloorplanProductMenuComponent } from "@project/floorplanner/floorplan-menu/fgds/floorplan-product-menu/floorplan-product-menu.component";
import { FloorplanService } from "@project/floorplanner/floorplan.service";
import { DraggedItemType, FloorplanDragDropService } from "@utils/floorplan-drag-drop.service";

@Component({
  selector: "app-floorplan-alarm-device-menu",
  templateUrl: "./floorplan-alarm-device-menu.component.html",
  styleUrls: ["./floorplan-alarm-device-menu.component.scss"],
  imports: [UiKitModule, FloorplanProductMenuComponent, ConfiguredProductComponent],
})
export class FloorplanAlarmDeviceMenuComponent {
  private floorplanService = inject(FloorplanService);
  private dragDropService = inject(FloorplanDragDropService);

  protected floorplan: Floorplan;

  protected readonly tooltipTextAlarmDevices: string = $localize`:@@global.alarmDevices:Alarmmittel`;

  constructor() {
    this.floorplan = this.floorplanService.selectedFloorplan;
  }

  protected get alarmDevices(): readonly AlarmDeviceConfiguration[] {
    if (this.floorplan.project instanceof FgdsProject) {
      return this.floorplan.project.alarmDevices;
    }
    return [];
  }

  protected addAlarmDevice(alarmDevice: AlarmDeviceConfiguration) {
    this.floorplanService.addAlarmDevice(alarmDevice);
  }

  protected addPlaceholder() {
    this.floorplanService.addAlarmDevicePlaceholder();
  }

  protected deleteAlarmDevice(alarmDevice: AlarmDeviceConfiguration) {
    (this.floorplan.project as FgdsProject).deleteAlarmDevice(alarmDevice);
  }

  protected drag(alarmDeviceConfig: AlarmDeviceConfiguration) {
    this.dragDropService.setDragged({ type: DraggedItemType.ALARM_DEVICE, config: alarmDeviceConfig });
  }

  protected dragPlaceholder() {
    this.dragDropService.setDragged({ type: DraggedItemType.ALARM_DEVICE_PLACEHOLDER });
  }

  protected updateAlarmDevicesItemTextVisibility(visible: boolean) {
    this.floorplan.floorplanState.updateAlarmDevicesItemTextVisibility(visible);
  }
}
